import { LSHelper } from '@/libs/localStorage';
import { FORMS_STATE_NAMESPACE } from './models/forms';
import { FLIGHTS_STATE_NAMESPACE } from './models/flights';
export const getPersistedState = () => {
    const localeStorageValue = LSHelper.get();
    if (!localeStorageValue) {
        return {};
    }
    const persistedState = {};
    if (localeStorageValue[FORMS_STATE_NAMESPACE]) {
        persistedState[FORMS_STATE_NAMESPACE] =
            localeStorageValue[FORMS_STATE_NAMESPACE];
    }
    if (localeStorageValue[FLIGHTS_STATE_NAMESPACE]) {
        persistedState[FLIGHTS_STATE_NAMESPACE] =
            localeStorageValue[FLIGHTS_STATE_NAMESPACE];
    }
    return persistedState;
};
